import request, { isSalesSupport } from '../utils/request';
import { getPathVariables } from '../misc';
import {
  businessConnectQuoteToolForm,
  orderStatus,
  businessConnectQuoteToolOrderCategoryName,
  quoteStatus,
  orderDetailsForm,
  fieldSubmittingOnBehalfOf
} from '../utils/constant';

export const isEligibilityForm = () => {
  const [, categoryName, formName] = getPathVariables(window.location.pathname);
  return (
    businessConnectQuoteToolOrderCategoryName === categoryName &&
    businessConnectQuoteToolForm === formName
  );
};

function submitPayload(formData, step) {
  const userProfile = request.getProfile();
  const { name, email, id: userId, role_id: roleId } = userProfile;
  const salesRepInfoForSRT = JSON.parse(
    localStorage.getItem('salesRepInfoForSRT')
  );
  const [, , formName] = getPathVariables(window.location.pathname);

  let payload = { ...formData };
  if (formName === businessConnectQuoteToolForm) {
    if (
      businessConnectQuoteToolOrderCategoryName === formData.categoryName &&
      businessConnectQuoteToolForm === formData.formName
    ) {
      const profile = salesRepInfoForSRT || request.getProfile();

      if (profile.channels && profile.channels.length) {
        const { channels } = profile;
        if (payload.channelId) {
          const channelName = channels.find(
            i => Number(i.id) === Number(payload.channelId)
          );
          payload.channelName = channelName && channelName.name;
        } else {
          const channelId = channels[0].id;
          payload.channelId = channelId;
          payload.channelStrId = `${channelId}`;
        }
      }
      delete profile.id;
      delete profile.province;
      delete profile.status;
      delete profile.createdAt;
      delete profile.updatedAt;

      payload.status = orderStatus.incomplete;
      payload.quoteStatus = quoteStatus.incomplete;
      payload.sendToSRT = false;

      payload = { ...profile, ...payload };
      payload.step = 2;
      payload.assignedToSRT = roleId === 4 ? userId : 0;
      payload.isQuoteReference = false;
      if (['Yes', 'Oui'].includes(payload[fieldSubmittingOnBehalfOf])) {
        payload.submitterName = name;
        payload.submitterEmail = email;
      }
    }
  } else if (formName === orderDetailsForm && step === 7) {
    if (!isSalesSupport) payload.status = orderStatus.pendingValidation;
  }

  if (formData.id) {
    const { id } = formData;
    return request.put(`/orders/${id}`, payload);
  }
  payload.currentSite = 1;
  return request.post('/orders', payload);
}

export default submitPayload;
